// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file financial/emitten/entity/v1/fr.proto (package financial.emitten.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum financial.emitten.entity.v1.FRBadges
 */
export const FRBadges = /*@__PURE__*/ proto3.makeEnum(
  "financial.emitten.entity.v1.FRBadges",
  [
    {no: 0, name: "FR_BADGES_UNSPECIFIED"},
    {no: 1, name: "FR_BADGES_TOP_SHORT_TERM"},
    {no: 2, name: "FR_BADGES_HIGHEST_YIELD"},
  ],
);

/**
 * @generated from message financial.emitten.entity.v1.FRAttributes
 */
export const FRAttributes = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v1.FRAttributes",
  () => [
    { no: 1, name: "bid_price", jsonName: "bid_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "offer_price", jsonName: "offer_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "due_date", jsonName: "due_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "performance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "yield", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "badges", kind: "enum", T: proto3.getEnumType(FRBadges), repeated: true },
  ],
);

/**
 * @generated from message financial.emitten.entity.v1.FRfitem
 */
export const FRfitem = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v1.FRfitem",
  () => [
    { no: 1, name: "annual_coupon_rate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "due_date", jsonName: "due_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "minimum_order", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "next_coupon_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "coupon_distribution", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "issued_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "bid_price", jsonName: "bid_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "offer_price", jsonName: "offer_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "performance", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "yield", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v1.FRDetail
 */
export const FRDetail = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v1.FRDetail",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_syariah", jsonName: "is_syariah", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "coupon_rate", jsonName: "coupon_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "due_date", jsonName: "due_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "publish_date", jsonName: "publish_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "publisher", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "coupon_returned_date", jsonName: "coupon_returned_date", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "min_order", jsonName: "min_order", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "order_multiples", jsonName: "order_multiples", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "memo_url", jsonName: "memo_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message financial.emitten.entity.v1.FRPrice
 */
export const FRPrice = /*@__PURE__*/ proto3.makeMessageType(
  "financial.emitten.entity.v1.FRPrice",
  () => [
    { no: 1, name: "buy_price_rate", jsonName: "buy_price_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "buy_yield", jsonName: "buy_yield", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "sell_price_rate", jsonName: "sell_price_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "sell_yield", jsonName: "sell_yield", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "return_rate", jsonName: "return_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

